import { styled } from "styled-components";
import Search from "../search/Search";
import Chat from "../chat/Chat";
import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "antd";
import { Loading, useAppLayout } from "@dataone/lib";
import TourSmartSearch from "../../../support/components/product-tour/TourSmartSearch";
import { StarChatIcon, StarSearchIcon } from "@dataone/icons";
interface TabProps {
  activeTab?: string;
  showResponse: boolean;
  setShowResponse: React.Dispatch<React.SetStateAction<boolean>>;
  setShowDocumentsViewer: (value: boolean) => void;
  setDocQuestion: (value: string) => void;
}
const textSearch = (
  <span style={{ color: "#000", fontSize: "12px" }}>
    Search in your data or documents ask and maipulate the results
  </span>
);
const textChat = (
  <span style={{ color: "#000", fontSize: "12px" }}>
    Conversational AI model for engaging, informative, and natural interactions
  </span>
);
const SmartSearchTab = ({
  activeTab,
  showResponse,
  setShowResponse,
  setShowDocumentsViewer,
  setDocQuestion,
}: TabProps) => {
  const stepRef1 = useRef(null);
  const stepRef2 = useRef(null);
  const stepRef3 = useRef(null);
  const stepRef4 = useRef(null);
  const stepRef5 = useRef(null);
  const stepRef6 = useRef(null);
  const stepRef7 = useRef(null);
  const stepRef8 = useRef(null);

  const [isOpen, setOpen] = useState(false);

  const [currentTab, setCurrentTab] = useState(activeTab || "search");
  const handleTabClick = (tab: string) => {
    if (tab === "chat") {
      useAppLayout.setState({ isResponseVisible: false });
      setShowResponse(false);
    }
    setCurrentTab(tab);
  };

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (currentTab === "search") {
      setIsLoading(true);
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [currentTab]);

  return (
    <TourSmartSearch
      stepRef1={stepRef1}
      stepRef2={stepRef2}
      stepRef3={stepRef3}
      stepRef4={stepRef4}
      stepRef5={stepRef5}
      stepRef6={stepRef6}
      stepRef7={stepRef7}
      stepRef8={stepRef8}
      setModalOpen={setOpen}
    >
      <StyledTab
        showResponse={showResponse}
        currentTab={currentTab === "search" ? true : false}
      >
        <div ref={stepRef1} className="tab-container">
          <input
            id="toggle-on"
            className="toggle toggle-left"
            name="toggle"
            value="false"
            type="radio"
            checked={currentTab === "search"}
          />
          <label htmlFor="toggle-on" className="btn">
            <Tooltip placement="bottom" title={textSearch} color="#fff">
              <div
                className={`tab-btn ${
                  currentTab === "search" ? "active-tab" : "inactive-tab"
                }`}
                ref={stepRef8}
                onClick={() => handleTabClick("search")}
              >
                <BtnContent>
                  <StyledIcon
                    currentTab={currentTab === "search" ? true : false}
                  >
                    <StarSearchIcon />
                  </StyledIcon>
                  <div
                    className={`name ${
                      currentTab === "search" ? "active-name" : "inactive-name"
                    }`}
                  >
                    Search
                  </div>
                </BtnContent>
              </div>
            </Tooltip>
          </label>
          <input
            id="toggle-off"
            className="toggle toggle-right"
            name="toggle"
            value="true"
            type="radio"
            checked={currentTab === "chat"}
          />
          <label htmlFor="toggle-off" className="btn">
            <Tooltip placement="bottom" title={textChat} color="#fff">
              <div
                ref={stepRef5}
                className={`tab-btn ${
                  currentTab === "chat" ? "active-tab" : "inactive-tab"
                }`}
                onClick={() => handleTabClick("chat")}
              >
                <BtnContent>
                  <StyledIcon
                    currentTab={currentTab === "search" ? false : true}
                  >
                    <StarChatIcon />
                  </StyledIcon>
                  <div
                    className={`name ${
                      currentTab === "chat" ? "active-name" : "inactive-name"
                    }`}
                  >
                    Consulting
                  </div>
                </BtnContent>
              </div>
            </Tooltip>
          </label>
        </div>
        <div className="tab-content">
          {currentTab === "search" &&
            (isLoading && showResponse ? (
              <div>
                <Loading />
              </div>
            ) : (
              <Search
                stepRef2={stepRef2}
                stepRef3={stepRef3}
                stepRef4={stepRef4}
                isOpen={isOpen}
                setOpen={setOpen}
                showResponse={showResponse}
                setShowResponse={setShowResponse}
                setShowDocumentsViewer={setShowDocumentsViewer}
                setDocQuestion={setDocQuestion}
              />
            ))}
          {currentTab === "chat" && (
            <Chat stepRef6={stepRef6} stepRef7={stepRef7} />
          )}
        </div>
      </StyledTab>
    </TourSmartSearch>
  );
};

export default SmartSearchTab;

const StyledTab = styled.div<{ showResponse: boolean; currentTab: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 32px;

  .inactive-tab {
    background: #eff1fd;
    box-shadow: none;
    border-radius: 25px;
  }
  .tab-content {
    width: 100%;
  }

  .tab-container {
    background: #eff1fd;
    border-radius: 25px;
    padding: 4px;
    margin-bottom: ${(props) =>
      props.currentTab ? (props.showResponse ? "20px" : "80px") : "inherit"};

    .btn {
      display: inline-block;
      position: relative;
      text-align: center;
      transition: background 600ms ease, color 600ms ease;
    }

    input[type="radio"].toggle {
      display: none;
      & + label {
        cursor: pointer;
        min-width: 61px;
        &:hover {
          background: none;
          color: #4974f6;
        }
        &:after {
          background: #4974f6;
          border-radius: 25px;
          content: "";
          height: 100%;
          position: absolute;
          top: 0;
          transition: left 200ms cubic-bezier(0.77, 0, 0.175, 1);
          width: 100%;
          z-index: -1;
        }
      }
      &.toggle-left + label {
        border-right: 0;
        &:after {
          left: 100%;
        }
      }
      &.toggle-right + label {
        margin-left: 10px;
        &:after {
          left: -100%;
        }
      }
      &:checked + label {
        cursor: default;
        color: #fff;
        transition: color 200ms;
        z-index: 1;
        &:after {
          left: 0;
        }
      }
    }
  }
`;

const BtnContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px 23px;
  // width: 120px;
  justify-content: center;
  .name {
    color: #eff1fd;
    font-size: 12px;
    font-weight: 700;
    margin-left: 10px;
    min-width: 50px;
  }
  .inactive-name {
    color: #8e8ea0;
  }
`;

const StyledIcon = styled.div<{ currentTab: boolean }>`
  display: flex;
  font-size: 18px;
  color: ${({ currentTab }) => (currentTab ? "#eff1fd" : "#8e8ea0")};
`;
